import React from 'react';
import { Page } from '../Page';
import { PullQuote } from '../PullQuote';
export function PageAlcohol() {
  return <Page pageNumber={36} variant="light" data-id="element-1232" data-mp="20a6c4tve54jx">
      <div className="flex flex-col h-full" data-id="element-1233" data-mp="207abuyw2m3sb">
        {/* Hero Image */}
        <div className="h-[200px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1234" data-mp="1w5ykantmz8hh">
          <img src="https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=1000&q=80" alt="Elegant drink" className="w-full h-full object-cover" data-id="element-1235" data-mp="1r7djonah2msi" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-1236" data-mp="1hhkfi7cnt9ya" />
        </div>

        <div className="mb-8" data-id="element-1237" data-mp="1cjsgktdlknkl">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1238" data-mp="18hxhzwn1woai">
            Side Effects
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1239" data-mp="13hswttb775dy">
            Navigating <span className="text-tealslate" data-id="element-1240" data-mp="yjhojn0jx2xu">Alcohol</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1241" data-mp="3u6sbpf7vlm7d" />
        </div>

        <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-1242" data-mp="3u5hbfpdn2wl0">
          <div className="space-y-4 text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1243" data-mp="2scv9otrkpnz">
            <p data-id="element-1244" data-mp="3l6cdak5zp59d">
              GLP-1 medications fundamentally change how your body processes
              alcohol. Many people find they lose their desire to drink
              entirely. This is because the medication dampens the dopamine
              reward pathway in the brain.
            </p>
            <p data-id="element-1245" data-mp="lqp6dg48k9m7">
              Reduced tolerance is real and well-documented. Because the
              medication slows digestion, alcohol may sit in your stomach
              longer, changing how and when it absorbs.
            </p>
          </div>
          <div className="space-y-4 text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1246" data-mp="copn0h5r0tg3">
            <p data-id="element-1247" data-mp="2sh5cfej2c3ky">
              Alcohol provides empty calories that compete with your
              already-reduced intake. When you can only eat 1,000 to 1,500
              calories a day, every calorie matters. Alcohol takes the place of
              nutrients your body desperately needs.
            </p>
            <p data-id="element-1248" data-mp="29duzyus95w3l">
              Additionally, alcohol impairs sleep quality, which compounds other
              side effects and undermines recovery.
            </p>
          </div>
        </div>

        <div className="mb-8 pl-4" data-id="element-1249" data-mp="1zlxl9e21cm04">
          <PullQuote text="Your tolerance is not what it used to be. Respect that." variant="light" data-id="element-1250" data-mp="1zkw8n55dfrga" />
        </div>

        <div className="mt-auto bg-[#EAEAE4] border border-[#D8D8D0] p-6 w-full" data-id="element-1251" data-mp="1pojek65wzbl0">
          <h3 className="font-serif text-xl text-[#1F1F1F] mb-4" data-id="element-1252" data-mp="1lmxt3wfbdoz7">
            Practical Guidance
          </h3>
          <ul className="grid grid-cols-2 gap-x-8 gap-y-4 text-xs text-[#7A7A70] leading-[1.6]" data-id="element-1253" data-mp="1gowcrj99w3rf">
            <li className="flex gap-3" data-id="element-1254" data-mp="3g1rzvllk77j0">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-1255" data-mp="3g0h0dxz5clxp">•</span>
              <span data-id="element-1256" data-mp="3b373jx9fh7zu">
                If you choose to drink, reduce your quantity significantly.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-1257" data-mp="3ileq6ork2vrc">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-1258" data-mp="3nk824cr72epe">•</span>
              <span data-id="element-1259" data-mp="3nievgxgkzuhe">Eat a protein-rich meal before drinking.</span>
            </li>
            <li className="flex gap-3" data-id="element-1260" data-mp="3sc9jue74sxmt">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-1261" data-mp="15ooiia1n3jz">•</span>
              <span data-id="element-1262" data-mp="16zt2kbbcfc5">
                Stay hydrated. Drink a full glass of water for every alcoholic
                drink.
              </span>
            </li>
            <li className="flex gap-3" data-id="element-1263" data-mp="34morx5t02q1e">
              <span className="text-tealslate font-bold mt-0.5" data-id="element-1264" data-mp="34nqcc0vwoovs">•</span>
              <span data-id="element-1265" data-mp="39jf8rvcmppnv">Be acutely aware of your new limits.</span>
            </li>
          </ul>
        </div>
      </div>
    </Page>;
}